<template>
  <AppHeader>Create new Group</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex flex-col p-3 bg-white rounded-2xl shadow-sm">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Group Name</p>
        <input v-model="form.name" ref="inputName" class="w-full text-xl placeholder:text-lg" placeholder="Enter Group name" type="text">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.name">{{ errors.name }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Group Notes</p>
        <textarea v-model="form.notes" class="w-full text-xl placeholder:text-lg" placeholder="Enter Group description, route or delivery boy"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.notes">{{ errors.notes }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createGroup">Create Group</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CreateGroup',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'idle',
      form: {},
    }
  },

  methods: {
    createGroup() {
      if (!this.validateForm(this.form, {name: 'required|notempty', notes: 'required|notempty'})) return;
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';
      this.form.dealer_id = this.$store.state.user.id;

      this.request('POST', 'groups', this.form, (resp) => {
        alert(resp.message);
        if (resp.success) {
          this.state = 'idle';
          this.$router.go(-1);
        }
      });
    },
  },

  mounted() {
    this.$refs.inputName.focus();
  },
}
</script>
